import { useRef } from "react";
import { v4 as uuidv4 } from 'uuid';

const useIdempotency = () => {
  const keyRef = useRef(null);

  const getKey = () => {
    if (!keyRef.current) {
      keyRef.current = uuidv4();
    }
    return keyRef.current;
  };

  const resetKey = () => {
    keyRef.current = null;
  };

  return {
    getKey,
    resetKey,
  };
};

export default useIdempotency;